import useAsync from 'react-use/lib/useAsync';
import { useSdk } from '@packlink/packlink-sdk-provider';

function useTracking(shipmentReference) {
  const sdk = useSdk();
  return useAsync(() => sdk.v1.tracking.getByShipmentReference(shipmentReference), [shipmentReference]);
}

export { useTracking };
//# sourceMappingURL=useTracking.js.map
